/**
 * Generates URL by joining base URL, culture and path.
 * @param baseUrl Base URL (e.g. https://example.com)
 * @param cultureName Culture (e.g. 'en-US')
 * @param urlPath Path (e.g. 'my-page/orders')
 * @returns Generated URL
 */
export const generateUrl = (baseUrl: string, cultureName: string, urlPath?: string): string =>
    [baseUrl, cultureName, urlPath].filter(Boolean).join('/');
